









































































	import { Vue, Component, Prop, TagService, TagFilter, Watch } from "../../Infrastructure/CorBase/CoreBase";  

				@Component
				export default class BaseTLModalDialogTag extends Vue {
					@Prop({ type: String, required: true, default: "" }) id!: string;
					@Prop({ type: Boolean, required: false, default: true }) use?: boolean; 
					@Prop({ type: Array, required: false }) selected!: any[]; //vybrano
                    @Prop({ type: String, required: false, default: "receiver" }) typeTagModal!: string; // k čemu se bude ukladat 1)content - media 2) taks - ulohy 3) default receiver - zařízení

					tagService: TagService = new TagService();
					options: any[] = [];
					selectedItems: any[] = [];
                    selectedItemsOld: any[] = [];
					idComponent = 0;
					name = '';
					initOld = false;

					formData = {
						id: 0 as number,
						name: '' as string,
						description: '' as string,
						idTenant: this.$store.state.idTenant as number,
						color: '#000000' as string
					};

					isChange() {
                        if (this.selectedItemsOld.length !== this.selectedItems.length) {
                            return false;
                        }

						for (let i = 0; i < this.selectedItemsOld.length; i++) {
                            if (!this.selectedItems.some((c: any) => c.id ==  this.selectedItemsOld[i].id)) {
                                return false;
                            }
                        }

                        return true;
					}
					showModal() {
						this.initOld = true;
					}

                    @Watch('selectedItems')
                    onPropertyChangedselectedItems(value: any, oldValue: any) {
					
						if (value !== oldValue && this.initOld) {
							this.initOld = false;
                            this.selectedItemsOld = [];
                            this.selectedItems.forEach(val => this.selectedItemsOld.push(Object.assign({}, val)));
                        }
                    }

					storno() {
						this.selectedItems = [];
                        this.selectedItemsOld.forEach(val => this.selectedItems.push(Object.assign({}, val)));
					}

					goBack() {
                        this.$bvModal.hide(this.id);
					}

					newTag = false;
					addNewTag(search: any, id: any) {					
						this.formData.name = search;
						//hluboka kopie
						let addTag = (JSON.parse(JSON.stringify(this.formData)));
						this.tagService.create(this.formData).then(res => {							
							addTag.id = res.data.id;
							this.selectedItems.push(addTag);
							this.options.push(addTag);
						});
					}
					selectedItemsName: any[] = []; 

					save(): void {					
                        if (this.typeTagModal == "task") {
							this.tagService.updateTaskTag(this.idComponent, this.selectedItems).then(response => {
								this.$emit('changeTags', this.selectedItems);
								this.$bvModal.hide(this.id);
							});
						}
                        else if (this.typeTagModal == "content" ) {
							this.tagService.updateContentTag(this.idComponent, this.selectedItems).then(response => {
                                this.$emit('changeTags', this.selectedItems);
                                this.$bvModal.hide(this.id);
                            });
						}
                        else if (this.typeTagModal == "receiver") {
                            this.tagService.updateReceiverTag(this.idComponent, this.selectedItems).then(response => {
                                this.$emit('changeTags', this.selectedItems);
                                this.$bvModal.hide(this.id);
                            });
                        }
					}

					setSelected(selected: any, idComponent: number, name: string) {
						this.initAllOptions();
						this.idComponent = idComponent;
						this.selectedItems = (JSON.parse(JSON.stringify(selected)));
						this.name = name;
						this.$nextTick(() => {
                            //@ts-ignore
                            this.$refs.searchField!.activate();  


                        })
					}




					initAllOptions(): void {
						let filter: TagFilter = new TagFilter(this.$store.state.idTenant, null);
						this.tagService.getAllByFilter(filter).then(response => {							
							this.options = response.data;
						});
					}					
										
					isVisible(): boolean {						
						return document.getElementById(this.id) != null;
					}

					goToEditTags(): void {
						this.$router.push({ name: 'TagList', params: { returnRoute: 'TODOcesaZpet' } });
					}

					setModalTag(type: string) {
						this.typeTagModal = type;
                    }


					created() {	
						if (this.use) {
							//this.initAllOptions();
							this.selectedItemsName = this.selected;
						}

					

					}

					selectTag() {
						return this.selected;
					}

					//priklad paci
					//example9: {
					//	mode: 'tags',
					//	value: [],
					//	placeholder: 'Select employees',
					//	search: true,
					//	trackBy: 'name',
					//	label: 'name',
					//	options: [
					//		{ name: 'Judy', color: 'redText' },
					//		{ name: 'Jane', color: 'greenText' },
					//		{ name: 'John', color: 'whiteText' },
					//		{ name: 'Joe', color: 'yellowText' },
					//	]
					//}	
	}



